import { ChevronLeft, ExternalLink } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

interface Section {
  icon: string
  title: string
  items: string[]
}

const sections: Section[] = [
  {
    icon: '🎟️',
    title: 'ตั๋วดิจิทัล (Digital Ticket)',
    items: [
      'ตั๋วดิจิทัลใช้สำหรับแลกเปลี่ยนเนื้อหาและบริการภายในแอปพลิเคชัน Amulet Digit เท่านั้น',
      'ตั๋วดิจิทัลไม่สามารถถอนเป็นเงินสด โอนให้ผู้อื่น หรือแลกเปลี่ยนเป็นสินค้าและบริการใดๆ นอกแอปพลิเคชันได้',
      'ตั๋วดิจิทัลไม่มีวันหมดอายุ ตราบใดที่บัญชีของท่านยังคงใช้งานอยู่',
      'Amulet Digit ขอสงวนสิทธิ์ในการปรับเปลี่ยนราคาตั๋วโดยแจ้งล่วงหน้าผ่านช่องทางของแอปพลิเคชัน',
    ],
  },
  {
    icon: '💳',
    title: 'การชำระเงิน',
    items: [
      'การชำระเงินผ่าน PromptPay ถือเป็นที่สิ้นสุด ไม่สามารถขอคืนเงินได้ ยกเว้นในกรณีที่ระบบล้มเหลวจากฝั่ง Amulet Digit',
      'เราใช้ระบบตรวจสอบสลิปอัตโนมัติ หากพบการปลอมแปลงสลิปหรือการใช้สลิปซ้ำ บัญชีจะถูกระงับทันที',
      'ตั๋วจะถูกเติมภายใน 5 นาทีหลังจากการชำระเงินได้รับการยืนยัน หากล่าช้ากว่านั้น กรุณาติดต่อทีมงาน',
    ],
  },
  {
    icon: '📜',
    title: 'ข้อสงวนสิทธิ์ด้านการเงินอิเล็กทรอนิกส์',
    items: [
      'ตั๋วดิจิทัลของ Amulet Digit ไม่ใช่เงินอิเล็กทรอนิกส์ (e-Money) ตามพระราชบัญญัติระบบการชำระเงิน พ.ศ. 2560',
      'Amulet Digit ไม่ได้เป็นสถาบันการเงินหรือผู้ให้บริการชำระเงิน และไม่อยู่ภายใต้การกำกับดูแลของธนาคารแห่งประเทศไทยในฐานะดังกล่าว',
      'มูลค่าของตั๋วดิจิทัลคงที่ตามที่กำหนดในแอปพลิเคชัน และไม่มีดอกเบี้ยหรือผลตอบแทนใดๆ เกิดขึ้น',
    ],
  },
  {
    icon: '🔮',
    title: 'ข้อสงวนสิทธิ์ด้านการทำนาย',
    items: [
      'การทำนายฝัน ดูดวง และเลขมงคลทั้งหมดในแอปพลิเคชันนี้ มีวัตถุประสงค์เพื่อความบันเทิงและความเชื่อส่วนบุคคลเท่านั้น',
      'Amulet Digit ไม่รับประกันความถูกต้องหรือผลลัพธ์ใดๆ จากการทำนาย และไม่รับผิดชอบต่อการตัดสินใจใดๆ ที่เกิดขึ้นจากการใช้บริการ',
      'ผลการทำนายสร้างขึ้นโดยระบบปัญญาประดิษฐ์และอยู่บนพื้นฐานของความเชื่อดั้งเดิม มิใช่คำแนะนำทางการเงิน กฎหมาย หรือการแพทย์',
      'ท่านควรใช้วิจารณญาณส่วนตัวในการตัดสินใจทุกครั้ง',
    ],
  },
  {
    icon: '🛡️',
    title: 'ข้อมูลส่วนบุคคล (PDPA)',
    items: [
      'เราเก็บข้อมูลเฉพาะที่จำเป็นสำหรับการให้บริการ ได้แก่ LINE User ID ชื่อแสดงผล และรูปโปรไฟล์',
      'ข้อมูลการทำนายฝันและพฤติกรรมการใช้งานถูกเก็บเพื่อปรับปรุงบริการและประสบการณ์ผู้ใช้',
      'เราไม่ขายหรือเปิดเผยข้อมูลส่วนบุคคลของท่านให้กับบุคคลภายนอกโดยไม่ได้รับความยินยอม',
      'ท่านมีสิทธิ์ขอลบข้อมูลของตนเองได้โดยติดต่อทีมงานผ่านช่องทางที่กำหนด',
    ],
  },
  {
    icon: '⚠️',
    title: 'ข้อปฏิบัติและการระงับบัญชี',
    items: [
      'ห้ามใช้บริการในทางที่ผิดกฎหมาย ทุจริต หรือสร้างความเสียหายต่อระบบและผู้ใช้อื่น',
      'การปลอมแปลงสลิป การใช้สลิปซ้ำ หรือการพยายามเจาะระบบ จะส่งผลให้บัญชีถูกระงับถาวรโดยไม่มีการคืนเงิน',
      'Amulet Digit ขอสงวนสิทธิ์ในการแก้ไข ระงับ หรือยกเลิกบริการบางส่วนหรือทั้งหมดโดยแจ้งล่วงหน้าตามความเหมาะสม',
    ],
  },
]

const LINE_OA_URL = 'https://line.me/R/ti/p/@538rqskd'

export default function TermsPage() {
  const navigate = useNavigate()
  const today = new Date()
  const thMonth = ['ม.ค.','ก.พ.','มี.ค.','เม.ย.','พ.ค.','มิ.ย.','ก.ค.','ส.ค.','ก.ย.','ต.ค.','พ.ย.','ธ.ค.']
  const dateStr = `${today.getDate()} ${thMonth[today.getMonth()]} ${today.getFullYear() + 543}`

  return (
    <div className="flex flex-col min-h-dvh pb-10" style={{ background: 'var(--color-bg)' }}>

      {/* Header */}
      <div className="flex items-center gap-3 px-4 pt-6 pb-4">
        <button onClick={() => navigate(-1)} style={{ color: 'var(--color-text-muted)' }}>
          <ChevronLeft size={24} />
        </button>
        <h1 className="text-lg font-bold" style={{ color: 'var(--color-text)' }}>
          ข้อกำหนดการใช้งาน
        </h1>
      </div>

      {/* Hero Banner */}
      <div className="mx-4 mb-5 p-5 rounded-3xl text-center"
           style={{ background: 'var(--gradient-gold)' }}>
        <div className="text-4xl mb-2">🪬</div>
        <h2 className="text-base font-bold text-white">Amulet Digit</h2>
        <p className="text-xs mt-1" style={{ color: 'rgba(255,255,255,0.8)' }}>
          ข้อกำหนดและเงื่อนไขการใช้บริการ
        </p>
        <div className="mt-3 inline-block px-3 py-1 rounded-full text-[10px] font-semibold"
             style={{ background: 'rgba(255,255,255,0.2)', color: '#fff' }}>
          อัปเดตล่าสุด: {dateStr}
        </div>
      </div>

      {/* Intro */}
      <div className="mx-4 mb-5 p-4 rounded-2xl card-amulet">
        <p className="text-sm leading-relaxed" style={{ color: 'var(--color-text)' }}>
          กรุณาอ่านข้อกำหนดและเงื่อนไขนี้อย่างละเอียดก่อนใช้บริการ การใช้แอปพลิเคชัน Amulet Digit
          ถือว่าท่านได้อ่านและยอมรับข้อกำหนดทั้งหมดนี้แล้ว
        </p>
      </div>

      {/* Sections */}
      <div className="mx-4 flex flex-col gap-4">
        {sections.map((section) => (
          <div key={section.title} className="rounded-2xl card-amulet overflow-hidden">
            <div className="px-4 py-3 flex items-center gap-2"
                 style={{ borderBottom: '1px solid var(--color-surface-3)' }}>
              <span className="text-lg">{section.icon}</span>
              <h3 className="text-sm font-bold" style={{ color: 'var(--color-gold-dark)' }}>
                {section.title}
              </h3>
            </div>
            <div className="px-4 py-3 flex flex-col gap-3">
              {section.items.map((item, idx) => (
                <div key={idx} className="flex gap-2.5">
                  <div className="mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0"
                       style={{ background: 'var(--color-gold-dark)' }} />
                  <p className="text-sm leading-relaxed" style={{ color: 'var(--color-text)' }}>
                    {item}
                  </p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Contact — คลิกได้ */}
      <a href={LINE_OA_URL}
         target="_blank"
         rel="noopener noreferrer"
         className="mx-4 mt-5 p-4 rounded-2xl block active:opacity-70 transition-opacity"
         style={{ background: 'var(--color-surface-2)', border: '1px dashed var(--color-surface-3)' }}>
        <p className="text-xs text-center leading-relaxed" style={{ color: 'var(--color-text-muted)' }}>
          หากมีข้อสงสัยหรือต้องการความช่วยเหลือ{'\n'}
          กรุณาติดต่อทีมงานผ่าน LINE Official Account
        </p>
        <div className="flex items-center justify-center gap-1.5 mt-2">
          <p className="text-xs font-semibold" style={{ color: 'var(--color-gold-dark)' }}>
            @amuletdigit
          </p>
          <ExternalLink size={11} style={{ color: 'var(--color-gold-dark)' }} />
        </div>
      </a>

      {/* Footer */}
      <p className="text-center text-[10px] mt-6 px-6" style={{ color: 'var(--color-text-soft)' }}>
        Amulet Digit ดำเนินการโดยทีมพัฒนาอิสระ ภายใต้กฎหมายไทย
      </p>
    </div>
  )
}
